<div class="flex items-stretch justify-between w-full px-10 pt-2 text-white header-container bg-brand-darkBlue">
  <app-sa-logo></app-sa-logo>

  <ng-container *ngIf="currentUser">
    <div class="nav">
      <a [routerLink]="['/dashboard']" [ngClass]="{ active: isDashboardActive }" id="a-dashboard-tab">Dashboard</a>
      <a [routerLink]="['/projects']" routerLinkActive="active" id="a-project-search-tab">Projects</a>
      <a [routerLink]="['/committees']" routerLinkActive="active" id="a-committee-search-tab">Committees</a>


      <a *ngIf="canAccessNormOrgPage" [routerLink]="['/nominating-organisations']" routerLinkActive="active"
        id="a-header-nom-org">
        Nominating Organisation
      </a>


      <a *ngIf="canAccessStandardsLibraryPage" [routerLink]="['/sa-library']" routerLinkActive="active"
        id="a-connect-sim-tab">
        Standards Library
      </a>
      <a *ngIf="canAccessStandardsLibrarySimPage && appUrls" href="{{ appUrls.simUrl }}" target="_blank"
        id="a-external-sim-tab" [ngClass]="{ active: isSaLibraryActive }">
        Standards Library
      </a>

      <a *ngIf="canAccessBallotsPage" [routerLink]="['/ballots']" routerLinkActive="active"
        id="a-ballots-tab">Ballots</a>

      <a *ngIf="appUrls" href="{{ appUrls.pcmsUrl }}" target="_blank" id="a-external-pcms-tab">
        Public Comment
      </a>
    </div>

    <div class="flex items-center justify-end nav-apps">
      <div *ngIf="!(appUrls && isSalesforceJsLoaded)" class="flex items-center justify-center flex-grow">
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      </div>

      <ng-container *ngIf="appUrls && committeeWorkspaceUrl && canAccessCommitteeWorkspacePage">
        <a target="_blank" [href]="committeeWorkspaceUrl" id="a-committee-workspace-tab">
          Committee Documents
        </a>
      </ng-container>

      <div>

        <button mat-button type="button" [matMenuTriggerFor]="userMenu" class="account-menu-trigger" id="a-user-menu"
          aria-label="User menu">
          <span class="account-menu-content">
            <span class="material-symbols-rounded account-icon">{{ accountCircle }}</span>
            <span class="account-menu-text">Account</span>
          </span>
        </button>
        <mat-menu #userMenu="matMenu" class="bg-white user-menu-panel">
          <div class="bg-white px-0" id="a-user-menu-option-name" role="presentation">
            <div class="flex min-w-0 flex-col" aria-label="Signed in user details">
              <span class="body-xlarge-bold block whitespace-normal break-words text-black font-normal">
                {{currentUser.firstName }} {{ currentUser.lastName }}
              </span>
              <span class="body-default-regular text-grey-800">{{ currentUser.email }}</span>
            </div>
          </div>

          <div class="py-4">
            <div class="w-[342px] h-px bg-grey-400"></div>
          </div>

          <a *ngIf="canShowProfileLink" mat-menu-item [href]="appUrls!.iamProfileUrl" target="_blank"
            rel="noopener noreferrer" id="a-user-menu-option-profile-link" class="profile-menu-link">
            <span class="flex min-w-0 items-center gap-2">
              <span class="material-symbols-rounded profile-menu-item-icon shrink-0" aria-hidden="true">{{ person
                }}</span>

              <span class="profile-menu-text text-base not-italic font-normal leading-6 text-grey-900">
                Manage your account
                <span class="sr-only">(opens in a new tab)</span>
              </span>

              <span class="material-symbols-rounded openInNew-icon shrink-0" aria-hidden="true">{{ openInNew }}</span>
            </span>
          </a>

          <button mat-menu-item type="button" class="group logout-menu-item text-black hover:bg-gray-200"
            (click)="handleLogout()" id="a-user-menu-option-logout-link">
            <span class="flex items-center gap-2">
              <span class="material-symbols-rounded profile-menu-item-icon" aria-hidden="true">{{ logout }}</span>
              <span class="text-base not-italic font-normal leading-6 text-grey-900 group-hover:underline">Log
                out</span>
            </span>
          </button>
        </mat-menu>
      </div>
      <div>
        <button mat-button class="text-2xl text-white " id="app-launcher" (click)="handleOpenAppLauncher()">
          <ng-container *ngIf="isSalesforceJsLoaded">
            <span class="text-4xl material-symbols-rounded">{{ apps }}</span>
          </ng-container>
          <mat-progress-spinner *ngIf="!isSalesforceJsLoaded" mode="indeterminate" diameter="24"></mat-progress-spinner>
        </button>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="appFeaturesSettings?.algoliaSearch" class="flex w-full px-16 pt-4 bg-darkBlue-700">
  <app-autocomplete-search-box class="flex w-full"></app-autocomplete-search-box>
</div>

<div id="{{ sfAppLauncherContainerId }}"></div>